import { render, staticRenderFns } from "./Plotly.vue?vue&type=template&id=a1265530&"
import script from "./Plotly.vue?vue&type=script&lang=js&"
export * from "./Plotly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1265530')) {
      api.createRecord('a1265530', component.options)
    } else {
      api.reload('a1265530', component.options)
    }
    module.hot.accept("./Plotly.vue?vue&type=template&id=a1265530&", function () {
      api.rerender('a1265530', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/charts/Plotly.vue"
export default component.exports